import React, { useMemo } from 'react';

function InfoBlock(props) {
    function getValueText() {
        if (typeof props.value === 'string') return props.value;

        const precision = props.precision !== undefined ? parseInt(props.precision, 10) : 2;
        if (!props.value) return 0;
        const value = parseFloat(props.value);
        if (!value) return 0;

        if (value > 1000000) return `${(value / 1000000).toFixed(precision)}M`;
        if (value > 1000) return `${(value / 1000).toFixed(precision)}k`;
        return value.toFixed(precision);
    }

    const infoBlock = useMemo(() => (
        <article className="admin-info-card">
            {props.children ? (
                <span className="admin-info-icon" aria-hidden="true">{props.children}</span>
            ) : null}
            <div>
                <p className="admin-info-title">{props.title}</p>
                <p className="admin-info-value">{getValueText()}</p>
            </div>
        </article>
    ), [props.value, props.title, props.precision]);

    return infoBlock;
}

export default InfoBlock;
